import classNames from 'classnames';
import * as React from 'react';
import styles from './FiltersWrapper.module.css';

interface FiltersWrapperTranslations {
    filters: string;
}

export interface FiltersWrapperProps {
    children: React.ReactElement;
    translations: FiltersWrapperTranslations;
    wrapper?: boolean;
}

export const FiltersWrapper: React.FunctionComponent<React.PropsWithChildren<FiltersWrapperProps>> = props => {
    const { children, translations, wrapper = true } = props;

    return (
        <div className={classNames(styles.Wrapper, wrapper && styles[`Variant--wrapper`])}>
            <h2 className="visuallyHidden">{translations.filters}</h2>
            <div className={styles.Outer}>
                <div className={styles.Inner}>{children}</div>
            </div>
        </div>
    );
};
